import { Button } from '@elladx/design-system';
interface BulkActionsBarProps {
    count: number;
    disabled: boolean;
    onCreateShipments: () => void;
    onDelete: () => void;
    onClear: () => void;
}
/** Dark strip that slides in over the address list when rows are selected. */
function BulkActionsBar({ count, disabled, onCreateShipments, onDelete, onClear }: BulkActionsBarProps) {
    return (<div className="bulk-bar">
      <span className="sel">{count} selected</span>
      <div className="bulk-actions">
        <Button type="button" className="accent" onClick={onCreateShipments} disabled={disabled} variant="primary">
          Create shipments
        </Button>
        <Button type="button" onClick={onDelete} disabled={disabled} variant="secondary">
          Delete
        </Button>
        <Button type="button" className="ghost" onClick={onClear} disabled={disabled} variant="secondary">
          Clear
        </Button>
      </div>
    </div>);
}
export default BulkActionsBar;
